// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o4of2","controls":"styles_controls__3veHD","charLimit":"styles_charLimit__njFR9","input":"styles_input__2csMu","send":"styles_send__37gW5"};